<template>
    <div class="default-main ba-table-box">
        <!-- 表格顶部菜单 -->
        <buttons :buttons="['back', 'columnDisplay', 'delete' ]" :access="['', '', '' ]"
                 :tableData="tableData" @btnClick="btnClick" ></buttons>

        <!-- 表格 -->
        <tables :tableData="tableData" :tableKey="$options.name" ></tables>

    </div>
</template>

<script>
    import buttons from '@/components/buttons.vue'
    import tables from '@/components/tables.vue'
    import dialogForm from '@/components/dialogForm.vue'
    import dialogTable from '@/components/dialogTable.vue'

    export default {
        name: "momentUpList",
        components:{
            buttons,
            tables,
            dialogForm,
            dialogTable,
        },
        data() {
            return {
                //region table数据
                tableData:{
                    form: {
                        page: 1,                //页数
                        limit: this.$tools.getLimit(this.$options.name), //条数
                        total: 0,               //总数
                    },
                    column: [
                        { type: 'selection' },
                        { type: 'index' },
                        { label: "订单单号", prop: 'orderNo', type: 'text', show:true, },
                        { label: "订单主题", prop: 'orderName', type: 'text', show:true, },
                        { label: "上传时间", prop: 'uploadStartDateTime', type: 'time', show:true, condition:"dates" },
                        { label: "上传人", prop: 'userName', type: 'text', show:true, },
                        { label: "上传备注", prop: 'note', type: 'text', show:true, },
                        { label: "上传类型", prop: 'mediaType', type: 'tag', show:true,
                            tags: [
                                {value:'0', type: '',text:'图片'},
                                {value:'1', type: 'success',text:'视频'}
                            ],
                        },
                        { label: "图片/视频", prop: 'img', type: 'image', show:true, },
                        { type: 'button', width:80, label: "操作",
                            buttons:[
                                { label:'删除', prop: 'deleteFile', type:'danger', icon:'Delete', access:''},
                            ],
                        },
                    ],
                    currRow: {},
                    data: [],
                    searchClick: res => {
                        this.searchClick();
                    },
                    btnClick: (type, row) => { this.tableBtnClick(type, row) },
                },
                //endregion
            }
        },
        methods: {

            /**
             * table操作点击
             */
            tableBtnClick(type, row){
                switch (type) {
                    //region 删除
                    case 'deleteFile':
                        this.$confirm("确定要删除上传的文件和此条记录么?", {
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.deleteClick([
                              {
                                id:row.id,
                                originResourceId:row.originResourceId
                              }
                            ]);
                        });
                        break;
                    //endregion
                }
            },

            /**
             * 按钮点击
             */
            btnClick(e){
                switch (e) {
                    //region 批量删除
                    case 'delete':
                        let resourceIds = [];
                        for (let i = 0; i < this.tableData.data.length; i++) {
                            if(this.tableData.data[i].select){
                                resourceIds.push({
                                 id:this.tableData.data[i].id,
                                  originResourceId:this.tableData.data[i].originResourceId
                                });
                            }
                        }
                        if(resourceIds.length == 0){
                            this.$message.warning("请选择要删除的记录!");
                            return;
                        }

                        this.deleteClick(resourceIds);
                        break;
                    //endregion
                    //region 返回
                    case 'back':
                        this.$tools.closeCurrRouter('themeOrder');
                        break;
                    //endregion
                }
            },

            /**
             * 删除点击
             */
            deleteClick(ids){
                return new Promise((resolve, reject) => {
                    this.$POST("/customer/EomsOssResource/delete", ids, "删除中...", false).then(res => {
                        this.$message.success("删除成功!");
                        this.searchClick();
                    })
                });
            },

            /**
             * 查询数据
             */
            searchClick(){
                let param = JSON.parse(JSON.stringify(this.tableData.form));
                if(this.tableData.form.uploadStartDateTime && this.tableData.form.uploadStartDateTime.length == 2){
                    param.startDateTime  = this.$dayjs(this.tableData.form.uploadStartDateTime[0]).format('YYYY-MM-DD') + " 00:00:00";
                    param.endDateTime = this.$dayjs(this.tableData.form.uploadStartDateTime[1]).format('YYYY-MM-DD') + " 23:59:59";
                }
                param.uploadStartDateTime = "";
                param.companyId = this.$store.state.companyInfo.companyId;
                param.shopId = this.$store.state.shopInfo.id;
                this.$POST("/customer/EomsOssResource/resources/info/page", param).then(res => {
                    for (let i = 0; i < res.data.records.length; i++) {
                        //根据类型设置图片或视频
                        if(res.data.records[i].mediaType == 0){
                            res.data.records[i].img = res.data.records[i].masterToken
                        }else{
                            res.data.records[i].img = res.data.records[i].mp4F1Token
                        }
                        res.data.records[i].mediaType = res.data.records[i].mediaType+''
                    }
                    this.tableData.data = res.data.records.filter(item=>item.display);
                    this.tableData.form.total = res.data.total
                })
            },

        },
        mounted() {
            //table列权限判断
            // this.$tools.checkTablePower(this.tableData.column);
        },

        activated() {
            //region 从订单跳转并查询信息
            if(this.$store.state.comParam && this.$store.state.comParam.name == "momentUpList"){
                this.tableData.form.orderNo = this.$store.state.comParam.value.orderNo;
                this.searchClick();
            }else{
                this.btnClick("back");
            }
            //endregion

        }
    }
</script>

<style scoped>

</style>
